import { isAbortedRequest, isMalformedResponse } from '../../_shared/fetch-json';

/**
 * The write may have committed, but Terra never read the answer: the 2xx body
 * failed its schema, or the request was cut off before the body arrived
 * (bd-ea20w saved-refresh rule; web twin: `lib/writeMayHaveLanded.ts`).
 */
export interface UnconfirmedWrite {
  unconfirmed: true;
}

export const UNCONFIRMED: UnconfirmedWrite = { unconfirmed: true };

export function writeMayHaveLanded(err: unknown): boolean {
  return isMalformedResponse(err) || isAbortedRequest(err);
}

export function isUnconfirmed(result: object): result is UnconfirmedWrite {
  return 'unconfirmed' in result;
}

/**
 * Run `write`; when it may have landed, run `refresh` and report `UNCONFIRMED`
 * instead of throwing. A real failure (HTTP error, network) still throws: that
 * write did not land, so a retry is safe.
 */
export async function settleWrite<T extends object>(
  write: () => Promise<T>,
  refresh: () => Promise<unknown> | void,
): Promise<T | UnconfirmedWrite> {
  try {
    return await write();
  } catch (err) {
    if (!writeMayHaveLanded(err)) throw err;
    await refresh();
    return UNCONFIRMED;
  }
}
